<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50"><g transform="translate(-.014 -.013)"><circle cx="25" cy="25" r="25" style="fill:#5a70ee" transform="translate(.014 .013)"/><path d="M1 22.927a1 1 0 0 1-1-1v-1.582a8 8 0 0 1 8-8h.675a8 8 0 0 1 8 8v1.582a1 1 0 0 1-1 1zM3.335 5.291A5.152 5.152 0 0 1 8.337 0a5.153 5.153 0 0 1 5 5.291 5.154 5.154 0 0 1-5 5.291 5.153 5.153 0 0 1-5.002-5.291z" style="fill:#fff" transform="translate(16.675 12.507)" fill="currentColor"/></g></svg>
</template>
<script>
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'ri-account-profile',
});
</script>
